import { useState, useEffect } from "react";
import { useSelector } from "react-redux";

const SecureImage = ({ src, alt = "image", className = "", children }) => {
  const [imageSrc, setImageSrc] = useState("/images/placeholder.png");
  const [hasError, setHasError] = useState(false);

  const { valuations, currentValuation } = useSelector(
    (store) => store.valuationsDetails
  );

  useEffect(() => {
    if (!src || src === "/images/placeholder.png" || hasError) return;

    const fetchImage = async () => {
      try {
        const response = await fetch(src, {
          headers: {
            Authorization: `Bearer ${valuations[currentValuation]?.authToken}`
          }
        });

        if (response.status === 401) {
          console.log("Unauthorized: Invalid or missing token");
          throw new Error("Unauthorized");
        }

        if (!response.ok) throw new Error("Failed to fetch image");

        const blob = await response.blob();
        const imageUrl = URL.createObjectURL(blob);

        setImageSrc(imageUrl);
      } catch (error) {
        console.error("Error loading image:", error);
        setImageSrc("/images/placeholder.png"); // Fallback image
        setHasError(true); // Marca que hubo un error
      }
    };

    fetchImage();
  }, [src, valuations, currentValuation, hasError]);

  return children ? (
    children(imageSrc)
  ) : (
    <img
      src={imageSrc}
      alt={alt}
      className={className}
      onError={({ currentTarget }) => {
        if (currentTarget.src !== "/images/placeholder.png") {
          currentTarget.onerror = null; // Evita el bucle infinito
          setImageSrc("/images/placeholder.png");
          setHasError(true); // Marca que hubo un error
        }
      }}
    />
  );
};

export default SecureImage;
